import i18n from "i18next";
import dayjs from "dayjs";
import { OpenInputDialogFunc } from "src/components/common/dialogs/input/useInputDialog.tsx";
import { OpenGenericDialogFunc } from "src/components/common/dialogs/GenericDialogContext.ts";
import { ControlChartStatisticsView } from "./analysis/ControlChartStatisticsView.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";
import { ControlChartSelectionApi } from "src/api/generated/spc/controlChart/api/controlChartSelectionApi.ts";
import { ControlChartActionApi } from "src/api/generated/spc/controlChart/api/controlChartActionApi";
import { concatWithPipe } from "src/utils/strings.tsx";

export async function askInputAndOpenControlChartCapabilityView({
	showInputDialog,
	openDialog,
	controlChartId,
	chartName,
	beforeDate,
}: {
	showInputDialog: OpenInputDialogFunc;
	openDialog: OpenGenericDialogFunc;
	controlChartId: number;
	chartName: string;
	beforeDate?: dayjs.Dayjs;
}) {
	const sampleSize = await showInputDialog({
		type: "integer",
		title: i18n.t("sample_size"),
		required: true,
		defaultValue: 200,
	});
	if (sampleSize == undefined) return;

	openDialog({
		title: chartName,
		size: "xl",
		content: (
			<ControlChartStatisticsView
				controlChartId={controlChartId}
				sampleSize={sampleSize}
				beforeDate={beforeDate}
			/>
		),
		agentContext: {
			key: defineAgentUiContextKey("spc.controlChart.statistics.dialog"),
			data: { controlChartId, sampleSize, beforeDate: beforeDate?.toISOString() ?? null },
			pathSegments: [i18n.t("capability")],
		},
	});
}

export async function updateControlChartsChartGroup({
	showInputDialog,
	controlChartId,
}: {
	showInputDialog: OpenInputDialogFunc;
	controlChartId: number;
}) {
	const newChartGroupId = await showInputDialog({
		type: "singleNumberSelect",
		title: i18n.t("select_new_chart_group"),
		required: true,
		defaultValue: null,
		fieldProps: {
			selection: {
				options: async () => {
					const chartGroups = await ControlChartSelectionApi.getControlChartGroups({
						parentGroupId: null,
					});
					return chartGroups.map((chartGroup) => ({
						value: chartGroup.chartGroupId,
						label: concatWithPipe(chartGroup.parentGroupName, chartGroup.name),
					}));
				},
			},
		},
	});
	if (newChartGroupId === undefined) return;

	await ControlChartActionApi.setControlChartGroup({
		controlChartId: controlChartId,
		newControlChartGroupId: newChartGroupId,
	});
}
